import styled from '../ThemeContext'

export const Description = styled.div`
  margin-top: 4px;

  & * {
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Messages/Message/Embed/elements/description.ts